export class QueryParams extends URLSearchParams {
  setCond(condition: boolean, name: string, value: string): void {
    if (condition) {
      this.set(name, value);
    } else {
      this.delete(name);
    }
  }
  setMaybe(name: string, value?: string | null): void {
    this.setCond(value !== undefined && value !== null, name, value!);
  }
}

export const PAGE_SIZE = 40;

export const setPagingDataZero = (data: QueryParams, currentPage: number) => {
  data.set('offset', `${currentPage * PAGE_SIZE}`);
  data.set('limit', `${PAGE_SIZE}`);
};

export const setPagingData = (data: QueryParams, currentPage: number) => {
  setPagingDataZero(data, currentPage - 1);
};
